import { recentSowChangesStoreKey } from './recentSowChanges.const';
import { AppStateWithRecentSOWChangesData as State } from './recentSowChanges.types';

const select = (state: State) => state[recentSowChangesStoreKey];

export const getIsLoading = (state: State) => select(state).isLoading;

export const getIsReportLoading = (state: State) =>
  select(state).isReportLoading;

export const getRecentSowChanges = (state: State) => select(state).data;

export const getCurrentPage = (state: State) => select(state).currentPage;

export const getTotalPagesNumber = (state: State) => select(state).totalPages;

export const getLimit = (state: State) => select(state).pageSize;

export const getCache = (state: State) => select(state).cache;

export const getFilters = (state: State) => select(state).filters;

export const getAreFiltersApplied = (state: State) =>
  select(state).areFiltersApplied;

export const getExecuteSowChangeReqState = (state: State) =>
  select(state).executeSowChangeReqState;
export const getRejectSowChangeReqState = (state: State) =>
  select(state).rejectSowChangeReqState;

export const getFromAndToDates = (state: State) =>
  select(state).filters.fromAndToDate;

export const getSortBy = (state: State) => select(state).sortBy;
export const getSortOrder = (state: State) => select(state).sortOrder;
